<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>{{ potentialDate.timeStamp | fullDateTime }}</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<h3>Termin verschieben</h3>
			<div v-if="isTypeApplicant" class="mt-2">
				<RadioGroup
					v-model="moveType"
					:options="moveTypeOptions"
					stacked
				/>
			</div>
			<div v-if="moveType" class="mt-3">
				<template v-if="moveType === moveTypes.suggestions">
					<JonInfo class="mb-3">
						<template #message>
							Empfehlung: Schlage 3 bis 5 Termine vor, damit es rascher und einfacher geht.
						</template>
					</JonInfo>
					<PotentialDates
						v-model="moveDates"
					/>
					<div class="text-right">
						<Button
							text="Termin(e) vorschlagen"
							:disabled="!moveDatesValid || sendingRequest"
							:loading="sendingRequest"
							class="mt-3"
							icon="checkmark"
							@click="sendMove"
						/>
					</div>
				</template>
				<template v-if="moveType === moveTypes.customer">
					<JonInfo class="mb-3">
						<template #message>
							Das Unternehmen/die Organisation wird informiert dass sie dir alternative Termine
							vorschlagen sollen.
						</template>
					</JonInfo>
					<div class="text-right">
						<Button
							text="Termin verschieben"
							class="mt-3"
							:disabled="sendingRequest"
							:loading="sendingRequest"
							icon="checkmark"
							@click="sendMove"
						/>
					</div>
				</template>
			</div>
		</main>
		<footer></footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/communication/appointment/move";
import Icon from "@/vue/icon/Icon";
import IconLink from "@/vue/common/IconLink";
import FormGroup from "@/vue/common/form/Group";
import InfoBox from "@/vue/common/InfoBox";
import Button from "@/vue/common/Button";
import {LIST_TYPE__APPLICANT} from "@/store/communication/appointment";
import {createFromString} from "@/helper/util/Time";
import {isDefined} from "@/helper/Value";
import Modify, {ACTION_DEFER} from "@/api/communication/appointment/Modify";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import PotentialDates from "@/vue/communication/conversation/message/reply/PotentialDates.vue";
import JonInfo from "@/vue/common/JonInfo.vue";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import {arrayIsNotEmpty} from "@/helper/Array";

const MOVE_TYPE_SUGGESTIONS = 'suggestions';
const MOVE_TYPE_CUSTOMER = 'customer';

export default {

	components: {
		RadioGroup,
		JonInfo,
		PotentialDates,
		IconLink,
		Icon,
		FormGroup,
		InfoBox,
		Button,
	},

	data ()
	{
		return {
			moveType: undefined,
			moveTypes: {
				suggestions: MOVE_TYPE_SUGGESTIONS,
				customer: MOVE_TYPE_CUSTOMER,
			},
			moveDates: [],
			sendingRequest: false,
		};
	},

	computed: {
		...mapState('communication/appointment/move', [
			'show',
			'potentialDate',
			'listType',
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		moveTypeOptions ()
		{
			return [
				{ value: MOVE_TYPE_SUGGESTIONS, text: 'Neue Termine vorschlagen'},
				{ value: MOVE_TYPE_CUSTOMER, text: 'Neue Termin-Vorschläge anfragen'},
			];
		},
		appointment ()
		{
			return this.potentialDate.appointment;
		},
		isTypeApplicant ()
		{
			return this.listType === LIST_TYPE__APPLICANT;
		},
		counterProposalMaxTime ()
		{
			if (!this.isTypeApplicant)
			{
				return undefined;
			}

			return this.appointment.counterProposalMaxTime
				? createFromString(this.appointment.counterProposalMaxTime)
				: undefined;
		},
		moveDatesValid ()
		{
			if (this.moveType !== MOVE_TYPE_SUGGESTIONS)
			{
				return true;
			}

			return isDefined(this.moveDates) && arrayIsNotEmpty(this.moveDates);
		},
	},

	methods: {
		...mapActions('communication/appointment/move', {
			closeFan: 'close',
		}),
		reset ()
		{
			this.moveType = undefined;
			this.moveDates = [];
		},
		close ()
		{
			this.reset();
			this.closeFan({});
		},
		async sendMove ()
		{
			this.sendingRequest = true;

			try
			{
				await new Modify()
					.setAppointmentId(this.appointment.id)
					.setAction(ACTION_DEFER)
					.setAlternativeDates(this.moveDates)
					.call();

				this.reset();

				this.closeFan({
					confirmed: true
				});
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		},
	},

	watch: {
		show (show)
		{
			if (show && !this.isTypeApplicant)
			{
				this.moveType = MOVE_TYPE_SUGGESTIONS;
			}
		}
	}
}
</script>
